import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";
import {
    ResponsiveContainer,
    BarChart,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    Bar,
} from "recharts";

/* ── Tab Helpers ── */
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
function CustomTabPanel({ children, value, index, ...other }: TabPanelProps) {
    return (
        <div role="tabpanel" hidden={value !== index} {...other}>
            {value === index && <>{children}</>}
        </div>
    );
}
function a11yProps(index: number) {
    return { id: `report-tab-${index}`, "aria-controls": `report-tabpanel-${index}` };
}

const engagementData = [
    { name: "Mon", submissions: 4 },
    { name: "Tue", submissions: 7 },
    { name: "Wed", submissions: 5 },
    { name: "Thu", submissions: 9 },
    { name: "Fri", submissions: 6 },
    { name: "Sat", submissions: 11 },
    { name: "Sun", submissions: 8 },
];

const ViewBusinessReport = () => {
    const navigate = useNavigate();
    const [valueTabs, setValueTabs] = React.useState(0);

    // Simulated record — in real use, pass via route state or fetch by ID
    const report = {
        id: 1,
        userName: "Aisha Khan",
        userEmail: "aisha.khan@example.com",
        category: "Fashion & Apparel",
        skills: "Digital & Design",
        startupBudget: "$5,000 - $10,000",
        time: "Part-time (20–30 hours/week)",
        experience: "First-time Entrepreneur",
        location: "Dubai, UAE",
        idea: "A sustainable clothing line made from recycled materials.",
        submittedOn: "12 March 2026",
        aiScore: "78/100",
        feasibility: "High",
        marketPotential: "Strong",
        suggestedPlan: "Starter Founder Pass",
    };

    return (
        <>
            <div className="main_title">
                <h1>Business Report Details</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> –{" "}
                    <button onClick={() => navigate("/fikra-lab-business-report")}>
                        Fikra Lab Business Report
                    </button>{" "}
                    – View
                </p>
            </div>

          
            <div className="cards">
                {/* ── TAB 0: Basic Information ── */}
               
                    <div className="view_page">

                        {/* Entrepreneur Details */}
                        <div className="section_box">
                            <h2>Entrepreneur Details</h2>
                            <div className="gap_p">
                                <div className="w_33">
                                    <h6>Full Name</h6>
                                    <p>{report.userName}</p>
                                </div>
                                <div className="w_33">
                                    <h6>Email</h6>
                                    <p>{report.userEmail}</p>
                                </div>
                                <div className="w_33">
                                    <h6>Location</h6>
                                    <p>{report.location}</p>
                                </div>
                                <div className="w_33">
                                    <h6>Submitted On</h6>
                                    <p>{report.submittedOn}</p>
                                </div>
                            </div>
                        </div>

                        {/* Business Idea */}
                        <div className="section_box">
                            <h2>Business Idea</h2>
                            <div className="gap_p">
                                <div className="w_33">
                                    <h6>Category</h6>
                                    <p>{report.category}</p>
                                </div>
                                <div className="w_33">
                                    <h6>Skills</h6>
                                    <p>{report.skills}</p>
                                </div>
                                <div className="w_33">
                                    <h6>Startup Budget</h6>
                                    <p>{report.startupBudget}</p>
                                </div>
                                <div className="w_33">
                                    <h6>Time Commitment</h6>
                                    <p>{report.time}</p>
                                </div>
                                <div className="w_33">
                                    <h6>Business Experience</h6>
                                    <p>{report.experience}</p>
                                </div>
                                <div className="w_100">
                                    <h6>Business Idea Description</h6>
                                    <p>{report.idea}</p>
                                </div>
                            </div>
                        </div>

                    </div>
            </div>
        </>
    );
};

export default ViewBusinessReport;
